<template>
    <div>
        <div class="product-small" v-if="preview">
            <v-card>
                <v-card-text>
                    <lsi-google :id="id" />
                </v-card-text>
            </v-card>
        </div>
        <div class="product-full" v-if="!preview">
            <v-card>
                <v-card-text>
                    <div class="d-flex align-center">
                        <v-tabs color="primary" v-model="tab">
                            <v-tabs-slider color="primary"></v-tabs-slider>
                            <v-tab href="#google">Google</v-tab>
                            <v-tab href="#suggestions">Suggestions</v-tab>
                            <v-tab href="#questions">Questions</v-tab>
                            <v-tab href="#dacide">Dacide</v-tab>
                            <!-- <v-tab href="#log">Log</v-tab> -->
                        </v-tabs>
                        <v-spacer />
                        <v-btn color="green" @click="exporto('questions')" depressed small class="d-flex white--text mr-1" :disabled="exporting">
                            <v-icon left dark v-if="!exporting || exporting !== 'questions'">mdi-export</v-icon>
                            <v-progress-circular indeterminate v-if="exporting == 'questions'" size="20" width="3" class="mr-3 ml-0" />
                            <span>Export questions</span>
                        </v-btn>
                        <v-btn color="green" @click="exporto('sheet')" depressed small class="d-flex white--text mr-1" :disabled="exporting">
                            <v-icon left dark v-if="!exporting || exporting !== 'sheet'">mdi-export</v-icon>
                            <v-progress-circular indeterminate v-if="exporting == 'sheet'" size="20" width="3" class="mr-3 ml-0" />
                            <span>Export sheet</span>
                        </v-btn>
                        <v-btn color="green" @click="exporto('full')" depressed small class="d-flex white--text" :disabled="exporting">
                            <v-icon left dark v-if="!exporting || exporting !== 'full'">mdi-export</v-icon>
                            <v-progress-circular indeterminate v-if="exporting == 'full'" size="20" width="3" class="mr-3 ml-0" />
                            <span>Full export</span>
                        </v-btn>
                    </div>
                    <v-tabs-items v-model="tab">
                        <v-tab-item value="google" class="mt-5">
                            <lsi-google :id="id" />
                        </v-tab-item>

                        <v-tab-item value="suggestions" class="mt-5">
                            <lsi-suggestions :id="id" />
                        </v-tab-item>

                        <v-tab-item value="questions" class="mt-5">
                            <lsi-questions :id="id" />
                        </v-tab-item>

                        <v-tab-item value="dacide" class="mt-5">
                            <lsi-dacide :id="id" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";

import LsiGoogle from "./Lsi.Google";
import LsiQuestions from "./Lsi.Questions";
import LsiSuggestions from "./Lsi.Suggestions";
import LsiDacide from "./Lsi.Dacide";

export default {
    data: () => ({
        exporting: null,
        tab: null
    }),
    mixins: [ProductMixin],
    components: { LsiGoogle, LsiQuestions, LsiSuggestions, LsiDacide },
    methods: {
        async exporto(type) {
            if (this.exporting)
                return;

            this.exporting = type;
            const result = await this.action("export", { type });

            location.href = result.url;
            
            this.exporting = null;
        }
    }
}
</script>